import { Language } from "../enums";

export const LANGUAGES = {
  [Language.English]: { nativeName: "English" },
  [Language.German]: { nativeName: "Deutsch" },
  [Language.French]: { nativeName: "Français" },
  [Language.Spanish]: { nativeName: "Español" },
  [Language.Italian]: { nativeName: "Italiano" },
  [Language.Portuguese]: { nativeName: "Português" },
  [Language.Chinese]: { nativeName: "简体中文" },
};

export const DEFAULT_TIMEZONE = "Etc/UTC";
